var _path, _g, _path2, _g2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgSegment = function SvgSegment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "segment_svg__a",
    width: 16,
    height: 6,
    x: 0,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93C8A2",
    d: "M15.01 14.99H0V9.165h15.01v5.823Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#segment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#93C8A2",
    fillRule: "evenodd",
    d: "M9.89 10.602H.763c-.421 0-.762-.321-.762-.718 0-.397.341-.718.762-.718H9.89c.42 0 .762.321.762.718 0 .397-.341.718-.762.718Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "segment_svg__b",
    width: 16,
    height: 6,
    x: 0,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#43AF79",
    d: "M15.01 14.99H0V9.165h15.01v5.823Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#segment_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43AF79",
    fillRule: "evenodd",
    d: "M7.933 15a7.78 7.78 0 0 1-2.183-.31c-.401-.117-.626-.52-.502-.898.125-.38.553-.592.954-.474a6.163 6.163 0 0 0 1.731.246c2.586 0 4.83-1.563 5.586-3.891.123-.38.549-.593.952-.476.402.115.628.517.505.896C14.023 13.027 11.193 15 7.933 15Z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#93C8A2",
    fillRule: "evenodd",
    d: "M15.105 6.954H5.976c-.42 0-.762-.32-.762-.717 0-.397.341-.718.762-.718h9.129c.42 0 .762.32.762.718 0 .396-.341.717-.762.717Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#43AF79",
    fillRule: "evenodd",
    d: "M1.619 6.955a.805.805 0 0 1-.223-.032C.994 6.807.767 6.405.89 6.026c.954-2.934 3.784-4.905 7.043-4.905.745 0 1.479.104 2.183.31.402.117.627.52.502.898-.124.379-.551.592-.953.473a6.228 6.228 0 0 0-1.732-.244c-2.584 0-4.83 1.563-5.586 3.891a.759.759 0 0 1-.728.508",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#93C8A2",
    fillRule: "evenodd",
    d: "M13.217 3.5c0 .397-.34.719-.761.719s-.762-.322-.762-.718c0-.397.341-.718.762-.718.42 0 .761.32.761.718Zm-9.044 9.121c0 .397-.341.718-.762.718-.42 0-.762-.321-.762-.718 0-.397.341-.718.762-.718.42 0 .762.321.762.718Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSegment);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;